import React from 'react';

import { Scene } from '../icons';

// Pre-computed (deterministic) rain streaks for the rain scene.
const RAIN_DROPS = Array.from({ length: 34 }, (_, i) => ({
    left: `${(i * 37) % 100}%`,
    animationDelay: `${-((i * 0.173) % 1.3).toFixed(2)}s`,
    animationDuration: `${(0.65 + ((i * 7) % 5) * 0.09).toFixed(2)}s`,
    opacity: 0.25 + ((i * 3) % 5) * 0.1,
}));

// Background layer: stars at night, falling rain in the rain scene (the gradient itself is CSS).
const Sky: React.FC<{ scene: Scene }> = ({ scene }) => (
    <div className="sky" aria-hidden="true">
        {scene === 'night' && <div className="stars" />}
        {scene === 'rain' && (
            <div className="rain">
                {RAIN_DROPS.map((style, i) => <i key={i} style={style} />)}
            </div>
        )}
    </div>
);

export default Sky;
